
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	components: {},
	props: {},
})
export default class Toast extends Vue {
	public $bvToast: any;

	public makeToast(content: string, title: string, variant: string, noAutoHide = false) {
		this.$bvToast.toast(content, {
			title,
			variant,
			solid: true,
			noAutoHide,
			toaster: 'b-toaster-top-right',
		});
	}
}
